export const renderFilterCellLotsAdm = (
  col,
  idx,
  context
) => {
  switch (col.admFilterType) {
    default:
      return (
        <th
          key={`filter-default-${idx}`}
          className="style_tbody_th"
          style={{ backgroundColor: context.colorFilterAction }}
        ></th>
      );
  }
};
